import React from 'react';
import { Navigate } from 'react-router';

import {
  APP_CONFIG_AGILE_SUITE,
  VIEW_PATHS_ORDER_MANAGER,
} from '@hcs/app-configs';
import { LayoutContent } from '@hcs/design-system';
import { LayoutGlobalHeaderChildren } from '@hcs/design-system';
import { GlobalHeaderExtendableProps } from '@hcs/hc-products';
import { HeaderContent } from '@hcs/order-manager';
import { OrderUpdatesProvider } from '@hcs/order-manager';

import { useNavigateViewOrder } from '../hooks/useNavigateViewOrder';
import { AgileSuiteNav } from '../navigation';
import {
  OrdersPage,
  ReportPdfPage,
  ReportSummaryPage,
  ViewOrderPage,
} from '../pages';

export const routes = (
  RedirectHoc: ({ children }: { children: React.ReactNode }) => JSX.Element,
  HeaderComponent: (props: GlobalHeaderExtendableProps) => JSX.Element,
) => {
  const Header = () => {
    const onClickOrder = useNavigateViewOrder();
    return (
      <HeaderComponent
        authenticatedAdditionalHeaderContent={
          <HeaderContent onClickOrder={onClickOrder} />
        }
      />
    );
  };
  return () => [
    {
      path: APP_CONFIG_AGILE_SUITE.rootPath,
      element: (
        <RedirectHoc>
          <LayoutGlobalHeaderChildren header={<Header />}>
            <AgileSuiteNav />
            <OrderUpdatesProvider>
              <LayoutContent />
            </OrderUpdatesProvider>
          </LayoutGlobalHeaderChildren>
        </RedirectHoc>
      ),
      children: [
        {
          path: `${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.ORDERS}`,
          element: <OrdersPage />,
        },
        {
          path: `${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.ORDER}/:id`,
          element: <ViewOrderPage />,
        },
        {
          path: `${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.REPORT_SUMMARY}`,
          element: <ReportSummaryPage />,
        },
        {
          path: APP_CONFIG_AGILE_SUITE.rootPath,
          element: (
            <Navigate
              to={`${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.ORDERS}`}
              replace
            />
          ),
        },

        {
          path: `${APP_CONFIG_AGILE_SUITE.rootPath}/${VIEW_PATHS_ORDER_MANAGER.PDF}`,
          element: (
            <RedirectHoc>
              <ReportPdfPage />
            </RedirectHoc>
          ),
        },
      ],
    },
  ];
};
